import { normalizarData, normalizarValor } from '../../utils/index';

/**
 * Retorna TRUE se o array de dados se parecer com o Extrato (Resumo) de Repasses da Getnet.
 */
export const detectar = (dadosArray) => {
    // Procura o cabeçalho nas primeiras 30 linhas
    for (let i = 0; i < Math.min(dadosArray.length, 30); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;
        
        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        if (
            cleanRow.includes('estabelecimento comercial') &&
            cleanRow.includes('data de vencimento') &&
            cleanRow.includes('bandeira / modalidade') &&
            cleanRow.includes('recebimento') &&
            cleanRow.includes('valor líquido')
        ) {
            return true;
        }
    }
    return false;
};

/**
 * Processa a aba Resumo da Getnet extraindo os repasses já realizados.
 */
export const processar = (dadosArray) => {
    let idxData = -1;
    let idxModalidade = -1;
    let idxRecebimento = -1;
    let idxValor = -1;
    let idxCabecalho = -1;

    // 1. Encontrar o cabeçalho
    for (let i = 0; i < Math.min(dadosArray.length, 30); i++) {
        const linha = dadosArray[i];
        if (!linha || !Array.isArray(linha)) continue;
        
        const cleanRow = linha.map(c => String(c || '').trim().toLowerCase());
        
        const possibleDataIdx = cleanRow.indexOf('data de vencimento');
        const possibleModalidadeIdx = cleanRow.indexOf('bandeira / modalidade');
        const possibleRecebimentoIdx = cleanRow.indexOf('recebimento');
        const possibleValorIdx = cleanRow.indexOf('valor líquido');

        if (possibleDataIdx !== -1 && possibleModalidadeIdx !== -1 && possibleValorIdx !== -1 && possibleRecebimentoIdx !== -1) {
            idxCabecalho = i;
            idxData = possibleDataIdx;
            idxModalidade = possibleModalidadeIdx;
            idxRecebimento = possibleRecebimentoIdx;
            idxValor = possibleValorIdx;
            break;
        }
    }

    if (idxCabecalho === -1) {
        throw new Error('Cabeçalho de Repasses da Getnet (Resumo) não encontrado.');
    }

    const repasses = [];

    // 2. Extrair dados
    for (let i = idxCabecalho + 1; i < dadosArray.length; i++) {
        const linha = dadosArray[i];
        if (!linha || linha.length === 0) continue;

        // Verifica o campo Recebimento (deve ser 'Realizado')
        const recebimentoStr = String(linha[idxRecebimento] || '').trim().toLowerCase();
        if (recebimentoStr !== 'realizado') {
            continue; // Ignora previsões "Futuro" e totalizadores
        }

        const dataRaw = linha[idxData];
        if (dataRaw === undefined || dataRaw === null || dataRaw === '') continue;

        const data = normalizarData(dataRaw);
        if (!data) continue;

        let valorRaw = linha[idxValor];
        if (valorRaw === undefined || valorRaw === null || valorRaw === '') continue;

        const valor = normalizarValor(valorRaw);
        if (valor === null || valor <= 0) continue;

        let tipo = String(linha[idxModalidade] || 'Venda').trim();
        // Capitalizar a primeira letra se for preciso, ou deixar como veio (ex: "Elo Crédito")
        if (!tipo) tipo = 'Venda';

        repasses.push({
            linha: i + 1,
            data: data,
            valor: valor,
            tipo: tipo,
            origem: 'Getnet'
        });
    }

    return repasses;
};
